/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrganizationDocumentTypeEnum } from '../models/OrganizationDocumentTypeEnum';
import type { ResponseData_Array_OrganizationDocumentResponse } from '../models/ResponseData_Array_OrganizationDocumentResponse';
import type { ResponseData_Boolean } from '../models/ResponseData_Boolean';
import type { ResponseData_OrganizationResponse } from '../models/ResponseData_OrganizationResponse';
import type { UpdateCurrentOrganizationCommand } from '../models/UpdateCurrentOrganizationCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrganizationService {
    /**
     * Получить данные организации
     * @returns ResponseData_OrganizationResponse OK
     * @throws ApiError
     */
    public static getApiV1Organization(): CancelablePromise<ResponseData_OrganizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization',
        });
    }
    /**
     * Обновить данные организации
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static putApiV1Organization({
        requestBody,
    }: {
        requestBody?: UpdateCurrentOrganizationCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organization',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Скачать документ
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiV1OrganizationFiles({
        fileId,
    }: {
        fileId: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/files/{fileId}',
            path: {
                'fileId': fileId,
            },
        });
    }
    /**
     * Получить список документов организации
     * @returns ResponseData_Array_OrganizationDocumentResponse OK
     * @throws ApiError
     */
    public static getApiV1OrganizationFiles1({
        documentTypeIds,
        dateFrom,
        dateTo,
        pageNumber,
        pageSize,
    }: {
        documentTypeIds?: Array<OrganizationDocumentTypeEnum>,
        dateFrom?: string,
        dateTo?: string,
        pageNumber?: number,
        pageSize?: number,
    }): CancelablePromise<ResponseData_Array_OrganizationDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization/files',
            query: {
                'documentTypeIds': documentTypeIds,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Загрузить документы
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1OrganizationFilesUpload({
        formData,
    }: {
        formData?: {
            uploads?: Array<Blob>;
            documentTypeIds?: Array<OrganizationDocumentTypeEnum>;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organization/files/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Заменить файл
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static putApiV1OrganizationFilesReplace({
        fileId,
        formData,
    }: {
        fileId: string,
        formData?: {
            file?: Blob;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organization/files/{fileId}/replace',
            path: {
                'fileId': fileId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Переименовать файл
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static putApiV1OrganizationFilesRename({
        fileId,
        requestBody,
    }: {
        fileId: string,
        requestBody?: string,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organization/files/{fileId}/rename',
            path: {
                'fileId': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Изменить тип файла
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static putApiV1OrganizationFilesSetDocumentType({
        fileId,
        requestBody,
    }: {
        fileId: string,
        requestBody?: OrganizationDocumentTypeEnum,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organization/files/{fileId}/setDocumentType',
            path: {
                'fileId': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
